import React from 'react'
// import AnchorLink from 'react-anchor-link-smooth-scroll'
import * as typeformEmbed from '@typeform/embed'
import { Link } from 'gatsby'

export default (props) => {
  let typeForm
  if (process && process.browser) {
    typeForm = typeformEmbed.makePopup(
      props.buttonUrl,
      {
        opacity: 55,
        buttonText: "Request Invite",
        hideScrollbars: true,
        onSubmit: function () {
          setTimeout(() => typeForm.close(), 2000)
        }
      }
    )
  }
  return <footer className={`footer section bg-light-primary text-gray pt-2 ${props.bgColor ? 'cb-light-bgcolor' : ''}`}>
    <div className="container">
      <div className="row">
        <div className="xlg-space"></div>
        <div className="col-12 col-lg-12 mx-auto">
          <div className="row">
            <div className="col-12 col-lg-3 mx-auto footer-logo-div no-padding">
              <img src="/img/pirlo-logo-1.png" className="logo-img footer-logo-img" alt="logo" />
            </div>
            <ul className="col-12 col-lg-2 nav col flex-column sm-font-size footer-navlink contact-us">
              <li className="nav-link nav-head text-uppercase font-weight__600 text-black base-font-size font-family-secondary">Contact Us</li>
              <li className="nav-item"><span className="nav-link text-gray">info@pirlo.io</span></li>
              <li className="nav-item"><span className="nav-link text-gray">440 N Wolfe Rd,</span></li>
              <li className="nav-item"><span className="nav-link text-gray">Sunnyvale, CA 94085</span></li>
            </ul>
            <ul className="col-12 col-lg-2 nav col flex-column sm-font-size footer-navlink">
              <li className="nav-link nav-head text-uppercase font-weight__600 text-black base-font-size font-family-secondary">Explore</li>
              <li className="nav-item">
                {
                  process.browser && props.path && props.path === "/" ?
                    <Link offset='50' to="#features" className="nav-link text-gray">Features</Link>
                    :
                    <Link to="/#features" className="nav-link text-gray">Features</Link>
                }
              </li>
              <li className="nav-item">
                {
                  process.browser && props.path && props.path === "/" ?
                    <>
                      <Link offset='50' to="#team" className="nav-link text-gray">Team</Link>
                    </>
                    :
                    <Link to="/#team" className="nav-link text-gray">Team</Link>
                }
              </li>
              <li className="nav-item">
                {/* eslint-disable-next-line  */}
                <a
                  href="#"
                  onClick={() => {
                    process && process.browser &&
                      typeForm.open()
                  }}
                  className="nav-link text-gray">
                  {props.buttonText ? props.buttonText : "Request Invite"}
                </a>
              </li>
            </ul>
            <ul className="col-12 col-lg-2 nav col flex-column sm-font-size footer-navlink">
              <li className="nav-link nav-head text-uppercase font-weight__600 text-black base-font-size font-family-secondary">&nbsp;</li>
              <li className="nav-item"><Link to="/faq" className="nav-link text-gray">FAQ</Link></li>
              <li className="nav-item">
                <a
                  // href="mailto:info@pirlo.io"
                  href="#"
                  onClick={() => {
                    process && process.browser &&
                      typeForm.open()
                  }}
                  className="nav-link text-gray"
                >Contact Us</a>
              </li>
            </ul>
            <ul className="col-12 col-lg-3 nav col flex-column sm-font-size footer-navlink align-self-center">
              <li className="nav-head text-gray base-font-size font-family-secondary text-center">© 2019 Pirlo. All rights reserved</li>
              <ul className="nav sm-font justify-content-center justify-content-lg-center">
                {
                  props.allsocialUrls.fbUrl &&
                  <li className="nav-item">
                    <a
                      href={props.allsocialUrls.fbUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link footer-nav-link pl-lg-0">
                      <img src="/img/iconfinder_Circled_Facebook.png" alt="Facebook" />
                    </a>
                  </li>
                }
                {
                  props.allsocialUrls.twitterUrl &&
                  <li className="nav-item">
                    <a
                      href={props.allsocialUrls.twitterUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link footer-nav-link">
                      <img src="/img/iconfinder_Circled_Twitter.png" alt="Twitter" />
                    </a>
                  </li>
                }
                {
                  props.allsocialUrls.linkedin &&
                  <li className="nav-item">
                    <a
                      href={props.allsocialUrls.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link footer-nav-link">
                      <img src="/img/iconfinder_Circled_Linkedin.png" alt="Linkedin" />
                    </a>
                  </li>
                }
                {
                  props.allsocialUrls.instagramUrl &&
                  <li className="nav-item">
                    <a
                      href={props.allsocialUrls.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link footer-nav-link">
                      <img src="/img/iconfinder_Circled_Instagram.png" alt="Instagram" />
                    </a>
                  </li>
                }
              </ul>
              {/* <li className="nav-item text-center"><a href="mailto:support@pirlo.app" className="nav-link p-0 text-gray">support@pirlo.app</a></li> */}
            </ul>
          </div>
        </div>
        <div className="md-space"></div>
      </div>
    </div>
  </footer>
}
